module.exports = __webpack_public_path__ + "static/my-photo-99859b11171eefc2c2aab08576a0396b.jpg";